import React from 'react'
import Header from './components/header/'
import Footer from './components/footer'

import { BrowserRouter as Router, Route } from 'react-router-dom'
import SeoAudit from './components/seo-audit'

function App() {
  return (
    <div>
      <Header />
      <Router>
        <Route path="/" component={SeoAudit} />
      </Router>
      <Footer />
    </div>
  )
}

export default App
